var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9H18V2H2V15.385L3.763 14H10V16H4.455L0 19.5V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H19C19.2652 0 19.5196 0.105357 19.7071 0.292893C19.8946 0.48043 20 0.734784 20 1V9ZM12.145 16.071C11.9505 15.3702 11.9505 14.6298 12.145 13.929L11.17 13.366L12.17 11.634L13.146 12.197C13.6552 11.6784 14.2962 11.3084 15 11.127V10H17V11.126C17.715 11.31 18.352 11.686 18.854 12.198L19.83 11.634L20.83 13.366L19.855 13.929C20.0495 14.6298 20.0495 15.3702 19.855 16.071L20.83 16.634L19.83 18.366L18.854 17.802C18.3449 18.3212 17.7039 18.6918 17 18.874V20H15V18.874C14.296 18.692 13.655 18.3214 13.146 17.802L12.17 18.366L11.17 16.634L12.145 16.071ZM16 17C16.5304 17 17.0391 16.7893 17.4142 16.4142C17.7893 16.0391 18 15.5304 18 15C18 14.4696 17.7893 13.9609 17.4142 13.5858C17.0391 13.2107 16.5304 13 16 13C15.4696 13 14.9609 13.2107 14.5858 13.5858C14.2107 13.9609 14 14.4696 14 15C14 15.5304 14.2107 16.0391 14.5858 16.4142C14.9609 16.7893 15.4696 17 16 17Z",
    fill: "#010101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSettings);
export default __webpack_public_path__ + "static/media/chat-settings.7dcc3b6cb69fee2e40b07c0e40905cf2.svg";
export { ForwardRef as ReactComponent };